import { render, staticRenderFns } from "./chatMessageView.vue?vue&type=template&id=c35e6ff6&scoped=true"
import script from "./chatMessageView.vue?vue&type=script&lang=js"
export * from "./chatMessageView.vue?vue&type=script&lang=js"
import style0 from "./chatMessageView.vue?vue&type=style&index=0&id=c35e6ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35e6ff6",
  null
  
)

export default component.exports